// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ic-z","heading":"Jc-z","brandPromo":"Kc-z"};